module.exports = "data:image/gif;base64,R0lGODlhfwAgAMIFAEa1s4Guk6XIs8jbz+bv6v///////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAcALAAAAAB/ACAAAAP0WLrc/jAuQKu9OFfJu/9g2GhkaYloqq4FxQ2bRLhsbd8t4OnczOPA4O4nIUJ8wqTSYaLxmsalFEeLDFpYa3XKtW0fOh1B9u2aUeVRlhw9u4eRMHbcLiDf+E9aQZ+z84AcexNrEXeBiCMkhEYliY8TiwpyCzCSkImOk4UBmpiInpQKlhqfmZeiBZ2XpnmOfUQCnq14oYWkGbSAtkS4GLquqH4FvhfAtcJio7PHXZ4Bt8zNU6+q0azT1Itj0L3S2UrPhbLY4OGX3QzFJ+baGgMDM/LxBKul7VIX61DG+Ev6LjaEoQDN3sAY/pLwWzgoIQuGCyElAAA7"


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/airlines/TV.gif
// module id = ejs8
// module chunks = 9